import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqData: FAQItem[] = [{
  question: '¿Qué recibo exactamente al comprar?',
  answer: 'Recibís 3 archivos PDF descargables: el ebook "33 Rituales para Soltar el Pasado", el Diario Terapéutico de Liberación Emocional y los 7 Rituales de Emergencia Emocional. Todo llega a tu email inmediatamente con acceso de por vida.'
}, {
  question: '¿Es un libro físico o digital?',
  answer: '100% digital en formato PDF. Lo recibís en tu correo al instante y podés leerlo en cualquier dispositivo: celular, tablet o computadora. Sin costo de envío ni esperas.'
}, {
  question: '¿Necesito experiencia previa en meditación o rituales?',
  answer: 'No. Los rituales están diseñados para ser accesibles para cualquier persona. No requieren conocimientos previos ni creencias espirituales específicas. Solo necesitás la disposición de crear un espacio intencional para vos.'
}, {
  question: '¿Sirve si estoy yendo a terapia?',
  answer: 'Sí, es excelente complemento. Los rituales trabajan en una capa diferente a la terapia verbal: le dan al sistema nervioso la experiencia del cierre, no solo la comprensión. Muchos profesionales lo recomiendan para trabajar entre sesiones.'
}, {
  question: '¿Qué materiales necesito para los rituales?',
  answer: 'Cosas simples que ya tenés en casa: papel, bolígrafo, vela, agua, tijeras, sal. Cada ritual tiene su lista de materiales específica. El costo es mínimo — la mayoría ya los tenés.'
}, {
  question: '¿Tengo que hacer los 33 rituales en orden?',
  answer: 'No. Podés elegir el ritual que más resuene con lo que estás viviendo en cada momento. El libro explica: no hay un orden correcto, dejá que tu intuición te guíe hacia el ritual que necesitás hoy.'
}, {
  question: '¿Puedo pagar en cuotas?',
  answer: 'Sí. A través de Mercado Pago podés elegir las opciones de financiación disponibles con tu tarjeta de crédito. Las cuotas aparecen al momento del pago.'
}, {
  question: '¿Qué pasa si no me sirve?',
  answer: 'Tenés garantía incondicional de 7 días. Si sentís que el material no es lo que esperabas, te devolvemos el 100% de tu dinero sin preguntas. Tu proceso debe ser libre de riesgo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number>(-1);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="s-dark fu" id="faq" data-id="element-78">
      <div className="c" data-id="element-79">
        <span className="slabel" data-id="element-80">Preguntas frecuentes</span>
        <h2 className="stitle" data-id="element-81">
          Preguntas <em className="text-[var(--gold-l)]" data-id="element-82">Frecuentes</em>
        </h2>
        <div className="div-line" data-id="element-83"></div>

        <div className="max-w-[700px] mx-auto mt-[52px] flex flex-col" data-id="element-84">
          {faqData.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-[rgba(232,150,12,0.14)] last:border-b-0" data-id="element-85">
                <button className="w-full bg-transparent border-none py-5 flex items-center justify-between gap-3.5 cursor-pointer text-center group" onClick={() => toggleFAQ(index)} data-id="element-86">
                  <span className="font-serif text-[clamp(1.1rem,3vw,1.3rem)] font-700 text-white transition-colors duration-200 group-hover:text-[var(--gold-l)] text-center w-full" data-id="element-87">
                    {item.question}
                  </span>
                  <svg className={`w-[17px] h-[17px] text-[var(--gold)] transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-88">
                    <polyline points="6 9 12 15 18 9" data-id="element-89" />
                  </svg>
                </button>
                <div className={`overflow-hidden transition-all duration-350 ease-in-out ${isOpen ? 'max-h-[320px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-90">
                  <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] pb-5 pr-7 text-left font-400" data-id="element-91">
                    {item.answer}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}